/* eslint-disable camelcase */

export enum OrderCheckStage {
  PROGRESS = 2,
  PASS = 4,
  CLOSE = 5,
}

export declare class IUserItem {
  id: number
  name: string
  account?: string
  phone?: string
  department?: string
  role?: string
}

export declare class IOrderCheckSettingListItem {
  reviewId: number
  reviewRules: string
  reviewStep: string
  reviewNames: IUserItem[]
}

interface BaseParams {
  user_id: number
  company_id: string
  page?: number
}

export declare class IOrderCheckParams implements BaseParams {
  user_id: number
  company_id: string
  page: number
  size?: number
  stage?: any
  [key: string]: any
}

export declare class IOrderCheckSettingParams implements BaseParams {
  user_id: number
  company_id: string
  flow_id: number
  name: string
}

export declare class IOrderCheckFlowParams implements BaseParams {
  user_id: number
  company_id: string
  is_check_order: number
  list: string
}
